import {observer} from "mobx-react";
import {useStore} from "../../../../../../../hooks";
import Alerts from "../../../../../../../elements/v2/Alerts/Alerts";
import {MarketingErrorMessages} from "../../../../../../../utils/enums";
import React from "react";

export const RedirectErrorAlert = observer(() => {
  const { marketingStore } = useStore();
  const { alert } = marketingStore;
  
  return (
    <>
      {alert.showRedirectError && (
        <Alerts
          severity={'warning'}
          width={"auto"}
          top={"61px"}
          right={"16px"}
          title={MarketingErrorMessages.REDIRECT_MESSAGE_DRAFT_ERROR.title}
          message={MarketingErrorMessages.REDIRECT_MESSAGE_DRAFT_ERROR.message}
          onClose={() => alert.showOrHide("showRedirectError")}
        />
      )}
    </>
  );
});
